module.exports = __webpack_public_path__ + "static/hero-e63d3e26a8a088b0c8b65eeac1bc9358.jpg";